/**
 * 3rd party APIS
 */
if (typeof window.USB === 'undefined') {
  // Define it
  window.USB = {};
}

window.$ = require('jquery');

window.jQuery = window.$;
require('jquery-ui');
window.moment = require('moment');

window._ = require('underscore');
window.accounting = require('accounting');

if (typeof window.USB.util === 'undefined') {
  window.USB.util = require('@pivot/util');
}
 